<template>
  <base-modal size="lg" hide-header hide-footer @close="$emit('close')">
    <div class="col-12" @click.stop="">
      <div class="col-12 p-2">
        <h3 class="nopads">
          {{ $t('common.import_from_file') }}
        </h3>
      </div>
      <div style="position: relative; height: 40vh; padding: .2em; text-align: left">
        <map-container
          ref="mapContainer"
          :find-user="false"
          @on-map-changed="mapChanged"
        />
      </div>
      <div
        v-if="importedStations && importedStations.length > 0"
        class="col-12"
      >
          <vue3-datatable
              ref="resultTable"
              :rows="importedStations"
              :columns="fields"
              :pagination="false"
              :sticky-header="true"
              height="100%"
              :sortable="true"
              skin="bh-table-compact"
              row-class="routa-table-row"
              cell-class="routa-table-cell"
          >
              <template #created_at="row">
                {{ getDateString(row.value.created_at) }}
              </template>
              <template #user="row">
                {{ row.value.user ? row.value.last_name + ' ' + row.value.first_name : '' }}
              </template>
        </vue3-datatable>
      </div>
      <!-- Hidden file input -->
      <input
          type="file"
          class="d-none"
          id="photo"
          accept="gt, csv"
          @change="handleFileInput"
          ref="fileInput"
      />
      <div class="col-12 p-1 pt-3 pb-3 button-container">
          <button
              type="button"
              class="btn btn-outline-primary form-button"
              @click="triggerFileInput"
          >
              {{ $t('import_file_wizard.import_file') }}
          </button>

        <button
          class="btn  btn-secondary form-button"
          :disabled="loading"
          @click.stop="$emit('close')"
        >
          {{ $t('common.close') }}
        </button>
        <button
          class="btn  btn-success form-button"
          :disabled="loading || !importedStations || importedStations.length < 1 "
          @click.stop="submitStations"
        >
          {{ $t('common.save') }}
        </button>
      </div>


      <div
        v-if="loading"
        id="loader"
        class="spinner"
      />
    </div>
  </base-modal>
</template>


<script>
import {restApi} from '../mixins/RestApiMixin'
import {timeUtils} from '@/components/mixins/TimeUtils'
import Vue3Datatable from "@bhplugin/vue3-datatable";
import {mapHelper} from '../mixins/MapMixin'
import MapContainer from "@/components/map/MapContainer";
import BaseModal from "@/components/BaseModal";
import {inject} from "vue";

export default {
    name: 'PowerStationsImporter',
    components: {BaseModal, MapContainer, Vue3Datatable},
    mixins: [restApi, mapHelper, timeUtils],
    props: {
        user: {
            type: Object,
            default: null
        },
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            importFile: null,
            importedStations: null,
            map: null,
            fields: [
                {field: 'location_name', title: this.$t('power_stations.location_name'), sort: false},
                {field: 'street', title: this.$t('power_stations.street'), sort: false},
                {field: 'city', title: this.$t('power_stations.city'), sort: false},
            ]
        }
    },
    watch: {
        importFile() {
            this.submitFile()
        }
    },

    mounted() {
        if(this.getMapSettingsIn(['center'])){
            let center = this.getMapSettingsIn(['center'])
            this.mapCenter = {
                y: center.lat,
                x: center.lng
            }
        }
        this.$nextTick(() => {
            this.map = this.$refs.mapContainer.getMap()
        })
    },

    methods: {
        mapChanged(map) {
            this.map = map
            if(this.getMapSettingsIn(['center'])){
                let center = this.getMapSettingsIn(['center'])
                this.map.zoomToPosition(center.lat, center.lng, this.map.getMapZoomLevel())
            }
        },

        handleFileInput(event) {
            const file = event.target.files[0]
            if (file) {
                this.importFile = file
            } else {
                this.importFile = null
            }
        },

        triggerFileInput() {
            // Trigger the file input to open the file dialog
            this.$nextTick(() => {
                const input = this.$refs.fileInput
                if (input) {
                    input.click()
                }
            })
        },

        submitFile() {
            this.hideStations()
            if (this.importFile) {
                let formData = new FormData()
                formData.append('importFile', this.importFile)
                this.loading = true
                this.restPostWithFile(this.powerStationImportUrl, {}, formData,
                    (response) => {
                        this.loading = false
                        this.importedStations = response
                        this.drawStations()
                    }, this.fail
                )
            }
        },
        fail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        },
        drawStations: function () {
            this.importedStations.forEach(function (station, idx) {
                this.drawStation(station, idx+1)
            }, this)
            // Center map to first station
            if (this.importedStations && this.importedStations.length > 0) {
                this.map.zoomToPosition(this.importedStations[0].position.y, this.importedStations[0].position.x)
            }
        },

        drawStation: function (station, idx) {
            let icon = this.map.getMarkerStore().getPowerStationIcon()
            this.map.showMapMarker(idx, this.POWER_CENTER, station.position.y, station.position.x, icon)
        },

        hideStations: function () {
            if (this.map) {
                this.map.removeMapItemsByType(this.POWER_CENTER)
            }
            this.visibleSigns = []
        },
        submitStations() {
            if (this.importedStations && this.importedStations.length > 0) {
                this.restAdd(this.powerStationBulkUrl, this.importedStations,
                    () => {
                        this.loading = false
                        this.importFile = null
                        this.hideStations()
                        this.showAlert(this.$t('street_lights.station_import_successful'), 'success')
                    }, this.fail
                )
            }
        }
    }
}
</script>
